async function copyStringToClipboard(stringToCopy) {
  navigator.clipboard.writeText(stringToCopy)
}

export default copyStringToClipboard;